/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `Otevírací doba`
};

const da_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `Åbningstider`
};

const de_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `Öffnungszeiten`
};

const en_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `Opening hours`
};

const es_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `Horario de apertura`
};

const fr_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `Horaires d'ouvertures`
};

const hu_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `Nyitvatartási idő`
};

const it_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `Orari di apertura`
};

const nl_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `Openingstijden`
};

const pl_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `Godziny otwarcia`
};

const pt_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `Horário de funcionamento`
};

const sv_opening_hours = /** @type {(inputs: {}) => string} */ () => {
	return `Öppettider`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const opening_hours = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.opening_hours(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("opening_hours", locale)
	if (locale === "cs") return cs_opening_hours(inputs)
	if (locale === "da") return da_opening_hours(inputs)
	if (locale === "de") return de_opening_hours(inputs)
	if (locale === "en") return en_opening_hours(inputs)
	if (locale === "es") return es_opening_hours(inputs)
	if (locale === "fr") return fr_opening_hours(inputs)
	if (locale === "hu") return hu_opening_hours(inputs)
	if (locale === "it") return it_opening_hours(inputs)
	if (locale === "nl") return nl_opening_hours(inputs)
	if (locale === "pl") return pl_opening_hours(inputs)
	if (locale === "pt") return pt_opening_hours(inputs)
	return sv_opening_hours(inputs)
};